import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import Expertise from './components/Expertise';
import Approach from './components/Approach';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import TermsOfService from './components/TermsOfService';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      <Routes>
        <Route path="/" element={
          <>
            <Navigation />
            <Hero />
            <Philosophy />
            <Expertise />
            <Approach />
            <Contact />
            <Footer />
          </>
        } />
        <Route path="/privacy-policy" element={
          <>
            <Navigation />
            <PrivacyPolicy />
            <Footer />
          </>
        } />
        <Route path="/cookie-policy" element={
          <>
            <Navigation />
            <CookiePolicy />
            <Footer />
          </>
        } />
        <Route path="/terms-of-service" element={
          <>
            <Navigation />
            <TermsOfService />
            <Footer />
          </>
        } />
      </Routes>
    </div>
  );
}

export default App;